import React, { useMemo } from "react";
import { currentLocals } from "../../languages/languages.js";
import { ThemeProvider } from "@mui/material/styles";
import "../../styles/OnBoarding.css";
import { lectraMuiTheme, MuiOnboarding, SupportedLocale } from "@lectra/mui-library";
import { Box, Typography } from "@mui/material";
import Cookies from "universal-cookie";

/*
import imgconvertpatterntoMDL from "../../images/Input.svg";
import imgconvertMDLfilesto from "../../images/Output.svg";
import mdlink from "../../images/connected-patterns.svg";
import download from "../../images/Download.svg";
import espegra from "../../images/conformation-stature.svg";
*/

/*import imgconvertpatterntoMDL from "https://assets.dev.mylectra.com/images/Input.svg";
import imgconvertMDLfilesto from "https://assets.dev.mylectra.com/images/Output.svg";
import mdlink from "https://assets.dev.mylectra.com/images/connected-patterns.svg";
import download from "https://assets.dev.mylectra.com/images/Download.svg";
import espegra from "https://assets.dev.mylectra.com/images/conformation-stature.svg";
*/

/*

Execute in that order
"@emotion/react": "^11.8.1",
"@emotion/styled": "^11.8.1",
"@lectra/auth-js": "^1.0.3",
"@lectra/ld-react-feature-flags": "^1.0.34",
"@lectra/mui-library": "^2.4.1",
"@lectra/mui-library-icons": "^2.0.14",
"@lectra/react-authentication": "^1.8.1",
"@mui/icons-material": "^5.4.4",
"@mui/material": "^5.4.4",
  
*/

function getUrlVars() {
  var vars = {};
  var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
    vars[key] = value;
  });
  return vars;
}
function getUrlParam(parameter, defaultvalue) {
  var urlparameter = defaultvalue;
  if (window.location.href.indexOf(parameter) > -1) {
    urlparameter = getUrlVars()[parameter];
  }
  return urlparameter;
}
const Whatisnew = ({ locale, user, mail }) => {
  ///Init visualization
  const cookies = new Cookies();
  let initwelcome =
    cookies.get("noMoreOnBoarding") === "1" ||
    cookies.get("noMoreOnBoarding") === "2" ||
    cookies.get("noMoreOnBoarding") === "3"
      ? false
      : true;
  let initwhatN = cookies.get("noMoreOnBoarding") !== "3" ? true : false;
  if (user === undefined) {
    initwelcome = false;
    initwhatN = false;
  }
  // inf connected model, both are false
  const Connected = getUrlParam("connected", "No");
  //alert(Connected);
  if (Connected == "Yes") {
    initwelcome = false;
    initwhatN = false;
  }
  const onboardingVisibleInitValue = useMemo(() => {
    const in_store = window.localStorage.getItem("on_boarding");
    if (in_store == null) return true;
    return JSON.parse(in_store);
  }, []);

  // variable of state
  const [onboardingVisible, setOnboardingVisible] = React.useState(onboardingVisibleInitValue);
  const [welcomeScreenVisible, setWelcomeVisible] = React.useState(initwelcome);
  const [whatsNewScreenVisible, setWhatsnewVisible] = React.useState(initwhatN);
  const [HideDoNotShowAgain, setHideDoNotShowAgain] = React.useState(false);

  // load texts
  locale = locale === undefined ? SupportedLocale.EN : locale;

  let Pattern_Converter_allows_you_to = currentLocals(locale).welcome.Pattern_Converter_allows_you_to;
  let latest_features = currentLocals(locale).whatisnew.Discover_the_latest_features;

  let welcometitle = currentLocals(locale).welcome.Welcome_to_Pattern_Converter;
  let followthisguided = currentLocals(locale).welcome.Follow_this_guided;
  let youareintheright = currentLocals(locale).welcome.You_are_in_the_right;
  let dear_user;
  if (user === null || user === "") {
    if (mail === null || mail === "") dear_user = currentLocals(locale).welcome.Hello_dear;
    else dear_user = currentLocals(locale).welcome.Hello_dear + " " + mail;
  } else dear_user = currentLocals(locale).welcome.Hello_dear + " " + user;
  let doyouneed = currentLocals(locale).welcome.Do_you_need;

  let convertpatterntoMDL = currentLocals(locale).welcome.Convert_pattern_to_MDL;
  let convertMDLfilesto = currentLocals(locale).welcome.Convert_MDL_files_to;

  let mdllinktext = currentLocals(locale).whatisnew.Support_motif_links;
  let espegratext = currentLocals(locale).whatisnew.Support_special_grading;
  let patternassistanttext = currentLocals(locale).whatisnew.Preview_converted_files;

  let ItemsDiscovery = [
    {
      image: "https://assets.mylectra.com/images/Input.svg",
      description: convertpatterntoMDL,
    },
    {
      image: "https://assets.mylectra.com/images/Output.svg",
      description: convertMDLfilesto,
    },
  ];
  let ItemsWhatIsNew = [
    {
      image: "https://assets.mylectra.com/images/picto-view.svg",
      description: patternassistanttext,
    },
    {
      image: "https://assets.mylectra.com/images/connected-patterns.svg",
      description: mdllinktext,
    },
    {
      image: "https://assets.mylectra.com/images/conformation-stature.svg",
      description: espegratext,
    },
    /*
    {
      image: "https://assets.mylectra.com/images/Download.svg",
      description: downloadtext,
    },
    */
  ];
  let ItemsOnboarding;
  if (welcomeScreenVisible === true) ItemsOnboarding = ItemsDiscovery;
  else ItemsOnboarding = ItemsWhatIsNew;

  function beguintheTour(welcomeScreenIsVisible) {
    let discoverytour = welcomeScreenIsVisible === true ? true : false;
    let thetour =
      discoverytour === true
        ? document.getElementById("theDiscoveryTour")
        : document.getElementById("thewhatisnewTour");
    thetour.click();

    const cookies = new Cookies();
    if (discoverytour) {
      cookies.set("noMoreOnBoarding", "2", { path: "/" });
    } else {
      cookies.set("noMoreOnBoarding", "3", { path: "/" });
    }
  }

  return (
    <div>
      <ThemeProvider theme={lectraMuiTheme}>
        <div style={{ display: "none" }}>
          <input id="WelComeVisiblebutton" type="button" onClick={() => setWelcomeVisible(false)} />
          <input id="whatsNewVisiblebutton" type="button" onClick={() => setWhatsnewVisible(true)} />
          <input id="onBoardingVisiblebutton" type="button" onClick={() => setOnboardingVisible(true)} />
          <input id="HideDoNotShowAgain" type="button" onClick={() => setHideDoNotShowAgain(true)} />
        </div>

        <MuiOnboarding
          // Key is only set to force component to reinstanciate to go back to first step, unnecessary in actual implementation

          key={welcomeScreenVisible + " " + whatsNewScreenVisible + " " + onboardingVisible}
          id="whatisnew"
          className="whatisnew"
          open={onboardingVisible}
          lang={locale}
          close={() => {
            window.localStorage.setItem("on_boarding", JSON.stringify(HideDoNotShowAgain));
            setOnboardingVisible(false);
          }}
          welcomeConfig={{
            title: welcometitle,
            subtitle: dear_user,
            isVisible: welcomeScreenVisible,
            doNotShowAgain: () => {
              const cookies = new Cookies();
              if (cookies.get("noMoreOnBoarding") === "1") cookies.set("noMoreOnBoarding", "2", { path: "/" });
              else cookies.set("noMoreOnBoarding", "1", { path: "/" });
            },
            //imageUrl: welcome,
            //imageUrl: welcome2,
            content: (
              <Box textAlign="center">
                <Typography variant="body1">
                  <br />
                  {doyouneed}
                  <br />
                  {youareintheright}
                  <br />
                  {followthisguided}
                </Typography>
              </Box>
            ),
          }}
          whatsNewConfig={{
            isVisible: whatsNewScreenVisible,
            doNotShowAgain: () => {
              const cookies = new Cookies();
              //alert("whatsNew 1 : " + cookies.get("noMoreOnBoarding"));
              if (cookies.get("noMoreOnBoarding") === "1") cookies.set("noMoreOnBoarding", "2", { path: "/" });
              else if (cookies.get("noMoreOnBoarding") === "2") cookies.set("noMoreOnBoarding", "3", { path: "/" });
              //alert("whatsNew 2 : " + cookies.get("noMoreOnBoarding"));
            },
            items: ItemsOnboarding,
            titleWithWelcome: Pattern_Converter_allows_you_to,
            titleWithoutWelcome: latest_features,
          }}
          //Begin The Tour Button belongs to the OnBoarging global; for all screens
          tourAction={true ? () => beguintheTour(welcomeScreenVisible) : undefined}
          hideDoNotShowAgain={HideDoNotShowAgain}
        />
      </ThemeProvider>
    </div>
  );
};

export default Whatisnew;
